import Campaign from "./Campaign";
import DocumentTemplate from "./DocumentTemplate";
import Signatory from "./Signatory";

export enum DocumentStatus {
  CREATE = "Created",
  PENDING = "Pending",
  SIGNED = "Signed",
  REJECTED = "Rejected",
}

export type Document = {
  id?: string;
  documentTemplate: DocumentTemplate;
  signatory: Signatory;
  campaign: Campaign;
  file?: string;
  status: DocumentStatus;
  actions?: string;
  signStart?: Date;
  signEnd?: Date;
  records?: string;
  creationTime?: string;
  signDate?: string;
  paymentId?: string;
  attachments?: string;
};

export default Document;
